import React from 'react';
import './about.css';

interface AboutProps {
    t: (key: string) => string;
}

const About: React.FC<AboutProps> = ( {t}: AboutProps ) => {

        return (
        <div className="about-project__main_wrapper">
            <div className="about-project__inner_wrapper">

                <div className="about-project__headline">
                    {t('tab_about_headline')}
                </div>

                <div dangerouslySetInnerHTML={{ __html: t('tab_about_paragraph') }} />

            </div>
        </div>
    )

}

export default About;
